import React from "react";

const About: React.FC = () => {
  return (
    <div className="beat-container w-full px-4 sm:px-8 md:px-12 xl:px-[248px]">
      <div
        className="inline-flex flex-col items-start justify-start gap-[14px] sm:gap-4 md:gap-[18px] lg:gap-5 w-full pt-[18px] sm:pt-5 md:pt-6 pb-[28px] sm:pb-8 md:pb-10"
        style={{
          width: "100%",
          background: "rgba(0, 0, 0, 0)",
        }}
      >
        <div
          className="text-[22px] sm:text-[24px] md:text-[26px] lg:text-[28px] leading-[30px] sm:leading-[32px] md:leading-[34px] lg:leading-[36px]"
          style={{
            alignSelf: "stretch",
            color: "#171717",
            fontFamily: "Playfair Display",
            fontWeight: "600",
            wordWrap: "break-word",
          }}
        >
          Welcome to Beatpost: A Quick Guide for New Users
        </div>

        <div
          className="text-[14px] sm:text-[15px] md:text-[16px] leading-[20px] sm:leading-[22px] md:leading-[24px]"
          style={{
            alignSelf: "stretch",
            color: "#525252",
            fontFamily: "Instrument Sans",
            fontWeight: "400",
            wordWrap: "break-word",
          }}
        >
          Beatpost is a social platform for writers, readers, and thinkers who value quality content and meaningful
          interactions. Here's how to get started and navigate the platform:
        </div>

        <div className="w-full flex flex-col gap-3 sm:gap-4 md:gap-5 rounded-[12px] border border-[#E5E5E5] bg-white p-4 sm:p-5 md:p-6">
          <div
            className="text-[18px] sm:text-[20px] leading-[24px] sm:leading-[26px]"
            style={{
              color: "#171717",
              fontFamily: "Playfair Display",
              fontWeight: "600",
              wordWrap: "break-word",
            }}
          >
            1. Frontpage
          </div>
          <ul
            className="text-[14px] sm:text-[15px] md:text-[16px] leading-[20px] sm:leading-[22px] md:leading-[24px] pl-[18px]"
            style={{
              color: "#525252",
              fontFamily: "Instrument Sans",
              fontWeight: "400",
              wordWrap: "break-word",
            }}
          >
            <li>Your main landing page.</li>
            <li>Shows the latest and most relevant articles across the platform.</li>
            <li>Think of it as a classic newspaper - curated, fresh, and uncluttered.</li>
          </ul>
        </div>

        <div className="w-full flex flex-col gap-3 sm:gap-4 md:gap-5 rounded-[12px] border border-[#E5E5E5] bg-white p-4 sm:p-5 md:p-6">
          <div
            className="text-[18px] sm:text-[20px] leading-[24px] sm:leading-[26px]"
            style={{
              color: "#171717",
              fontFamily: "Playfair Display",
              fontWeight: "600",
              wordWrap: "break-word",
            }}
          >
            2. The Edition
          </div>
          <ul
            className="text-[14px] sm:text-[15px] md:text-[16px] leading-[20px] sm:leading-[22px] md:leading-[24px] pl-[18px]"
            style={{
              color: "#525252",
              fontFamily: "Instrument Sans",
              fontWeight: "400",
              wordWrap: "break-word",
            }}
          >
            <li>Your personal feed.</li>
            <li>Displays articles from users you follow, so you never miss their latest posts.</li>
            <li>Perfect for keeping up with writers whose voices matter to you.</li>
          </ul>
        </div>

        <div className="w-full flex flex-col gap-3 sm:gap-4 md:gap-5 rounded-[12px] border border-[#E5E5E5] bg-white p-4 sm:p-5 md:p-6">
          <div
            className="text-[18px] sm:text-[20px] leading-[24px] sm:leading-[26px]"
            style={{
              color: "#171717",
              fontFamily: "Playfair Display",
              fontWeight: "600",
              wordWrap: "break-word",
            }}
          >
            3. The Pulse
          </div>
          <ul
            className="text-[14px] sm:text-[15px] md:text-[16px] leading-[20px] sm:leading-[22px] md:leading-[24px] pl-[18px]"
            style={{
              color: "#525252",
              fontFamily: "Instrument Sans",
              fontWeight: "400",
              wordWrap: "break-word",
            }}
          >
            <li>Explore trending content across all hashtags.</li>
            <li>
              Articles here are ranked by popularity and engagement, helping you discover what the community is
              currently reading and discussing.
            </li>
          </ul>
        </div>

        <div className="w-full flex flex-col gap-3 sm:gap-4 md:gap-5 rounded-[12px] border border-[#E5E5E5] bg-white p-4 sm:p-5 md:p-6">
          <div
            className="text-[18px] sm:text-[20px] leading-[24px] sm:leading-[26px]"
            style={{
              color: "#171717",
              fontFamily: "Playfair Display",
              fontWeight: "600",
              wordWrap: "break-word",
            }}
          >
            4. Voices
          </div>
          <ul
            className="text-[14px] sm:text-[15px] md:text-[16px] leading-[20px] sm:leading-[22px] md:leading-[24px] pl-[18px]"
            style={{
              color: "#525252",
              fontFamily: "Instrument Sans",
              fontWeight: "400",
              wordWrap: "break-word",
            }}
          >
            <li>A directory of all active users who have published at least one post.</li>
            <li>Browse profiles, see what others are writing, and find new voices to follow.</li>
          </ul>
        </div>

        <div className="w-full flex flex-col gap-3 sm:gap-4 md:gap-5 rounded-[12px] border border-[#E5E5E5] bg-white p-4 sm:p-5 md:p-6">
          <div
            className="text-[18px] sm:text-[20px] leading-[24px] sm:leading-[26px]"
            style={{
              color: "#171717",
              fontFamily: "Playfair Display",
              fontWeight: "600",
              wordWrap: "break-word",
            }}
          >
            5. Writing and Posting
          </div>
          <ul
            className="text-[14px] sm:text-[15px] md:text-[16px] leading-[20px] sm:leading-[22px] md:leading-[24px] pl-[18px]"
            style={{
              color: "#525252",
              fontFamily: "Instrument Sans",
              fontWeight: "400",
              wordWrap: "break-word",
            }}
          >
            <li>Create your own articles with up to three hashtags to categorize your work.</li>
            <li>Keep it clean, focused, and engaging—the platform rewards quality over quantity.</li>
            <li>Each post contributes to your Mojo score, a measure of your popularity and engagement.</li>
          </ul>
        </div>

        <div className="w-full flex flex-col gap-3 sm:gap-4 md:gap-5 rounded-[12px] border border-[#E5E5E5] bg-white p-4 sm:p-5 md:p-6">
          <div
            className="text-[18px] sm:text-[20px] leading-[24px] sm:leading-[26px]"
            style={{
              color: "#171717",
              fontFamily: "Playfair Display",
              fontWeight: "600",
              wordWrap: "break-word",
            }}
          >
            6. Interacting
          </div>
          <ul
            className="text-[14px] sm:text-[15px] md:text-[16px] leading-[20px] sm:leading-[22px] md:leading-[24px] pl-[18px]"
            style={{
              color: "#525252",
              fontFamily: "Instrument Sans",
              fontWeight: "400",
              wordWrap: "break-word",
            }}
          >
            <li>Read, comment, and like posts to engage with the community.</li>
            <li>Share your thoughts but always prioritize meaningful conversation.</li>
          </ul>
        </div>

        <div
          className="flex flex-col p-[16px] sm:p-[18px] md:p-[20px] gap-[12px] sm:gap-[14px] md:gap-[16px]"
          style={{
            alignSelf: "stretch",
            background: "white",
            borderRadius: "12px",
            outline: "1px #E5E5E5 solid",
            outlineOffset: "-1px",
          }}
        >
          <div
            className="text-[18px] sm:text-[20px] leading-[24px] sm:leading-[26px] mt-[8px] sm:mt-[10px]"
            style={{
              alignSelf: "stretch",
              color: "#171717",
              fontFamily: "Playfair Display",
              fontWeight: "600",
              wordWrap: "break-word",
            }}
          >
            Tips for New Users
          </div>
          <ul
            className="text-[14px] sm:text-[15px] md:text-[16px] leading-[20px] sm:leading-[22px] md:leading-[24px] pl-[18px] list-disc list-inside"
            style={{
              color: "#525252",
              fontFamily: "Instrument Sans",
              fontWeight: "400",
              wordWrap: "break-word",
            }}
          >
            <li>Explore The Pulse to see trending topics.</li>
            <li>Follow users in Voices whose content inspires you.</li>
            <li>Focus on quality, not volume; well-crafted articles rise faster on Frontpage and The Pulse.</li>
          </ul>
          <div
            className="text-[14px] sm:text-[15px] md:text-[16px] leading-[20px] sm:leading-[22px] md:leading-[24px]"
            style={{
              color: "#525252",
              fontFamily: "Instrument Sans",
              fontWeight: "400",
              wordWrap: "break-word",
              marginTop: "8px",
            }}
          >
            Beatpost is designed for thoughtful reading and writing. Take your time, explore, and let your voice be
            heard.
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
